import React from 'react'
import { Box, Typography, Button } from '@material-ui/core'
import { ArrowBack } from '@material-ui/icons'
import { useHistory } from 'react-router-dom'
import { routeCodes } from 'constants/routes'

interface Props {
  redirectLogin?: boolean
  onClick?: () => void
}

export const GoBack: React.FC<Props> = ({ redirectLogin, onClick }) => {
  const history = useHistory()

  const handleClick = () => {
    if (onClick) {
      onClick()
    } else {
      redirectLogin ? history.push(routeCodes.NULL_ROUTE) : history.goBack()
    }
  }

  return (
    <Box mb={1}>
      <Button startIcon={<ArrowBack fontSize='small' />} onClick={handleClick}>
        <Typography variant='subtitle2'>VOLTAR</Typography>
      </Button>
    </Box>
  )
}

export default GoBack
